import React from 'react';
import styles from './Guarantee.module.scss';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

interface IGuaranteeProps {
  className?: string;
  iconComponent?: any;
  label?: string;
  children?: any;
  onClick?: any;
}

const Guarantee = (props: IGuaranteeProps) => {
  return (
    <div className={`${styles.guarantee} ${props.className}`.trim()} onClick={props.onClick}>
      <span className={styles.icon}>
      {props.iconComponent}
      </span>
      <span className={styles.label}>
        {props.label}
        {props.children}
      </span>
    </div>
  );
};

Guarantee.defaultProps = {
  className: '',
  iconComponent: <CheckCircleOutlineIcon/>,
  onClick: () => {
  },

};

export default React.memo(Guarantee);
